import React, { useEffect, useRef, memo } from 'react';
import './index.css';

function TradingViewWidget() {
	const container = useRef(null);

	useEffect(() => {
		const target = container.current;
		if (!target) {
			return () => undefined;
		}

		if (target.querySelector('script')) {
			return () => undefined;
		}

		const script = document.createElement('script');
		script.src = 'https://s3.tradingview.com/external-embedding/embed-widget-crypto-coins-heatmap.js';
		script.type = 'text/javascript';
		script.async = true;
		script.innerHTML = `
    {
      "dataSource": "CryptoWithoutBTC",
      "blockSize": "market_cap_calc",
      "blockColor": "24h_close_change|5",
      "locale": "ru",
      "symbolUrl": "",
      "colorTheme": "dark",
      "backgroundColor": "rgba(0, 0, 0, 0)",
      "hasTopBar": true,
      "isDataSetEnabled": true,
      "isZoomEnabled": true,
      "hasSymbolTooltip": true,
      "isMonoSize": false,
      "width": "100%",
      "height": "100%"
    }`;
		target.appendChild(script);

		return () => {
			target.querySelectorAll('script').forEach((node) => node.remove());
		};
	}, []);

	return (
		<div className="heatmap-widget">
			<div className="tradingview-widget-container" ref={container}>
				<div className="tradingview-widget-container__widget"></div>
				<div className="tradingview-widget-copyright">
					<a href="https://ru.tradingview.com/heatmap/crypto/" rel="noopener nofollow" target="_blank">
						<span className="blue-text">Track all markets on TradingView</span>
					</a>
				</div>
			</div>
		</div>
	);
}

const TradingViewWidgetMemo = memo(TradingViewWidget);

export const HeatMapContainer = () => (
	<div className="heatmap-panel">
	
		<div className="heatmap-panel__body">
			<TradingViewWidgetMemo />
		</div>
	</div>
);